import { useDispatch, useSelector } from "react-redux";
import styles from "../Components/ProductList.module.css";
import { bagActions } from "../store/bagSlice";

const BagItem = ({ item }) => {    
  const productQuantities = useSelector(store => store.bag.bagListQuantity); 
  let productQty = productQuantities.find((productQuantity) => productQuantity.id === item.id); 
  
  const dispatch = useDispatch();
  const handleRemove = () => {
    dispatch(bagActions.removeFromBag(item.id));     
  }
  const handleAddQuantity = () => { 
    let quantity = productQty.id===item.id ?  productQty.quantity : 1;    
    if(quantity>=1 && quantity<item.product_in_stock){ 
      dispatch(bagActions.addQuantity({id:item.id,quantity:quantity})); 
    }   
    
  }
  const handleDeductQuantity = () => { 
    let quantity = productQty.id===item.id ?  productQty.quantity : 1; 
    if(quantity>1){
      dispatch(bagActions.subQuantity({id:item.id,quantity:quantity}));      
    }  
         
  }  
    return (
      <>
        <div className="card mb-3">
          <div className="row g-0">
            <div className="col-md-4">              
              <p id={`${styles.rcorners1}`}><img
                      src={`${global.config.live_url}${item.product_image}`}
                      className="card-img-top"
                      alt="..." width="200px" height="150px"
                    /></p>
            </div>
            <div className="col-md-4">
              <div className="card-body">        
                
                <p className="card-text">
                  <small className="text-muted">{item.product_name}</small>
                </p>
                <p className="card-text">
                  <small className="text-muted">{item.product_weight} {item.product_unit}</small>
                </p>
                <p className="card-text">
                  <small className="text-muted">
                    &#x20B9;{" "}
                      {item.product_offer > 0
                        ? Math.round(
                            item.product_price -
                              (item.product_price * item.product_offer) / 100
                          )
                        : ""}{" "}
                      {item.product_offer > 0 ? (
                        <span className={styles.productPriceLineThrough}>
                          &#x20B9;{item.product_price}
                        </span>
                      ) : (
                        item.product_price
                      )}{" "}
                  </small>
                </p>
              </div>
            </div>
            <div className="col-md-4">              
              <p><button onClick={handleRemove} className="btn btn-outline-danger">Delete</button></p>
              <button onClick={handleDeductQuantity} type="button" className="btn btn-info">-</button>
              <span>&nbsp; {productQty.id===item.id ? productQty.quantity : 1} &nbsp;</span>
              <button onClick={handleAddQuantity} type="button" className="btn btn-info">+</button>
                           
            </div>
          </div>
        </div>
      </>
    );
    
}
export default BagItem;